export function initPartnersCarousel() {
  const root = document.querySelector("[data-partners-carousel]");
  if (!root) return;

  const viewport = root.querySelector("[data-partners-viewport]");
  const track = root.querySelector("[data-partners-track]");
  const prev = root.querySelector("[data-partners-prev]");
  const next = root.querySelector("[data-partners-next]");
  const slides = Array.from(root.querySelectorAll("[data-partners-slide]"));

  if (!viewport || !track || slides.length < 2) return;

  const mobileQuery = window.matchMedia("(width < 64rem)");
  let index = 0;

  const maxIndex = () => Math.max(0, slides.length - 1);

  const slideStep = () => {
    const slide = slides[0];
    if (!slide) return 0;

    const trackStyles = window.getComputedStyle(track);
    const gap = parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
    return slide.getBoundingClientRect().width + gap;
  };

  const setTransform = (offset, { animate = true } = {}) => {
    track.style.transitionProperty = animate ? "" : "none";
    track.style.transform = `translate3d(-${offset}px, 0, 0)`;
  };

  const update = () => {
    setTransform(index * slideStep());

    if (prev) prev.disabled = index <= 0;
    if (next) next.disabled = index >= maxIndex();
  };

  const goTo = (nextIndex) => {
    index = Math.min(Math.max(nextIndex, 0), maxIndex());
    update();
  };

  prev?.addEventListener("click", () => goTo(index - 1));
  next?.addEventListener("click", () => goTo(index + 1));

  let pointerId = null;
  let startX = 0;
  let startY = 0;
  let startOffset = 0;
  let deltaX = 0;
  let tracking = false;
  let horizontal = null;

  const stopTracking = () => {
    tracking = false;
    pointerId = null;
    horizontal = null;
    window.removeEventListener("pointermove", onPointerMove);
    window.removeEventListener("pointerup", onPointerUp);
    window.removeEventListener("pointercancel", onPointerUp);
  };

  const onPointerMove = (event) => {
    if (!tracking || event.pointerId !== pointerId) return;

    const dx = event.clientX - startX;
    const dy = event.clientY - startY;

    if (horizontal === null) {
      if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
      horizontal = Math.abs(dx) > Math.abs(dy);
      if (!horizontal) {
        stopTracking();
        return;
      }
    }

    deltaX = dx;
    event.preventDefault();
    setTransform(startOffset - deltaX, { animate: false });
  };

  const onPointerUp = (event) => {
    if (!tracking || event.pointerId !== pointerId) return;

    const movedHorizontally = horizontal === true;
    const distance = deltaX;
    stopTracking();

    if (!movedHorizontally) {
      update();
      return;
    }

    const step = slideStep();
    const threshold = Math.min(48, step * 0.15);

    if (Math.abs(distance) >= threshold) {
      goTo(index + (distance < 0 ? 1 : -1));
    } else {
      update();
    }

    const suppressClick = (clickEvent) => {
      clickEvent.preventDefault();
      clickEvent.stopImmediatePropagation();
      viewport.removeEventListener("click", suppressClick, true);
    };
    viewport.addEventListener("click", suppressClick, true);
  };

  viewport.addEventListener("pointerdown", (event) => {
    if (!mobileQuery.matches || event.pointerType === "mouse" || event.button !== 0) return;

    tracking = true;
    horizontal = null;
    pointerId = event.pointerId;
    startX = event.clientX;
    startY = event.clientY;
    startOffset = index * slideStep();
    deltaX = 0;

    window.addEventListener("pointermove", onPointerMove, { passive: false });
    window.addEventListener("pointerup", onPointerUp);
    window.addEventListener("pointercancel", onPointerUp);
  });

  window.addEventListener("resize", update, { passive: true });
  update();
}
